import React from 'react';

const YourRights = ({ onMenu }) => {
  const handleSubmitRequest = () => {
    if (onMenu) onMenu('new-request');
  };

  const rights = [
    {
      id: 1,
      icon: '🔍',
      title: 'Right to Access',
      section: 'Section 11(a)',
      description: 'You have the right to obtain confirmation and a summary of your personal data being processed, along with details of processing activities.',
      benefits: [
        'Know what data is collected',
        'Understand how it\'s used',
        'Identify who has access'
      ]
    },
    {
      id: 2,
      icon: '✏️',
      title: 'Right to Correction',
      section: 'Section 11(b)',
      description: 'You can request correction of inaccurate or misleading personal data, and completion of incomplete data.',
      benefits: [
        'Correct errors in your data',
        'Update outdated information',
        'Complete missing details'
      ]
    },
    {
      id: 3,
      icon: '🗑️',
      title: 'Right to Erasure',
      section: 'Section 11(c)',
      description: 'You can request erasure of your personal data when it\'s no longer necessary or when you withdraw consent.',
      benefits: [
        'Delete unnecessary data',
        'Remove data after consent withdrawal',
        'Erase data when purpose is fulfilled'
      ]
    },
    {
      id: 4,
      icon: '📢',
      title: 'Right to Grievance Redressal',
      section: 'Section 11(d)',
      description: 'You have the right to register complaints about data processing with our Data Protection Officer.',
      benefits: [
        'File complaints about misuse',
        'Report privacy violations',
        'Seek resolution of concerns'
      ]
    },
    {
      id: 5,
      icon: '👤',
      title: 'Right to Nominate',
      section: 'Section 11(e)',
      description: 'You can nominate another individual to exercise your rights in case of death or incapacity.',
      benefits: [
        'Designate a representative',
        'Ensure continuity of rights',
        'Protect your digital legacy'
      ]
    },
    {
      id: 6,
      icon: '📋',
      title: 'Right to Information',
      section: 'Section 11(a)',
      description: 'You have the right to know the identities of Data Fiduciaries and Data Processors.',
      benefits: [
        'Know who processes your data',
        'Understand data sharing',
        'Track data flow'
      ]
    }
  ];

  return (
    <div className="your-rights-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div className="page-header-text">
            <h1>Your Rights Under DPDP Act 2023</h1>
            <p>
              The Digital Personal Data Protection Act, 2023 empowers you with comprehensive rights
              to control your personal data. Learn about your rights and how to exercise them.
            </p>
          </div>
          <button type="button" className="page-header-back-btn" onClick={() => window.history.back()}>
            ← Back
          </button>
        </div>
      </div>

      {/* Rights Grid */}
      <div className="rights-grid">
        {rights.map((right) => (
          <div key={right.id} className="right-card">
            <div className="card-header">
              <span className="card-icon-inline">{right.icon}</span>
              <div>
                <div className="card-title">{right.title}</div>
                <div className="card-section">{right.section}</div>
              </div>
            </div>
            <div className="card-description">
              {right.description}
            </div>
            <ul className="card-benefits">
              {right.benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

     

      {/* CTA Section */}
      <div className="cta-section">
        <h2>Ready to Exercise Your Rights?</h2>
        <p>Submit a data protection request and we'll process it according to DPDP Act guidelines.</p>
        <button className="cta-button" onClick={handleSubmitRequest}>
          Submit a Request →
        </button>
      </div>

       {/* Info Section */}
     
        <div className="info-highlight">
          <p>
            ℹ️ Important: We may require identity verification before processing certain requests 
            to ensure the security of your personal data.
          </p>
        </div>
    </div>
  );
};

export default YourRights;
